import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal/modal.service';
import { UserProgressService } from '../../services/progress/user-progress.service';
import { UserProgressCourseProxy, CourseProgressItem } from '../../models/proxies/user-progress-course.proxy';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';
import { LessonService } from '../../services/lesson/lesson.service';

@Component({
  selector: 'uni-course-progress-details-modal',
  templateUrl: './course-progress-details-modal.component.html',
  styleUrls: ['./course-progress-details-modal.component.scss'],
})
export class CourseProgressDetailsModalComponent implements OnInit {

  public constructor(
    private readonly modalService: ModalService,
    private readonly userProgressService: UserProgressService,
    private readonly toastService: NzNotificationService,
    private readonly router: Router,
    private readonly lessonService: LessonService,
  ) {}

  @Input()
  public modalId: string = '';

  @Input()
  public courseId: string = '';

  public isLoading: boolean = true;

  public userProgress: UserProgressCourseProxy | null = null;

  //#region Lifecycle Hooks

  public async ngOnInit(): Promise<void> {
    const [progress, error] = await this.userProgressService.getUserProgress(this.courseId);

    if (error) 
      return void this.toastService.error('Ops...', error);

    this.userProgress = progress || null;

    this.isLoading = false;
  }

  //#endregion

  //#region Public Methods

  public close(): void {
    this.modalService.destroy(this.modalId);
  }

  public statusClass(status: string, type: string): string {
    if(status === 'Concluído' && type === 'quiz') return 'progress-badge--awaiting-correction';
    if(status === 'Concluído' && type === 'lesson') return 'progress-badge--completed';
    if(status === 'Reprovado') return 'progress-badge--failed';
    if(status === 'Pendente') return 'progress-badge--pending';
    if(status === 'Aguardando correção') return 'progress-badge--awaiting-correction';
    return 'progress-badge--pending';
  }

  public async redirectToLessonOrQuiz(items: CourseProgressItem): Promise<void> {
    if(items.type === 'lesson' && items.lessonId)
      await this.router.navigate(['/main/cursos', items.slug, 'modulos', items.moduleId, 'aulas', items.lessonId]);

    if(items.type === 'quiz' && items.quizId) await this.checkQuizNavigation(items);

    this.close();
  }

  //#endregion

  //#region Private Methods

  private async checkQuizNavigation(items: CourseProgressItem): Promise<void> {
    const [canMakeQuiz, error] = await this.lessonService.checkCurrentModuleProgress(items.moduleId);

    if (error) return void this.toastService.error('Ops...', error, { nzKey: 'key'});
    if (!canMakeQuiz) return void this.toastService.error('Ops...', 'É necessário fazer todas as aulas do módulo para iniciar a avaliação.');

    await this.router.navigate(['/main/cursos', items.slug, 'modulos', items.moduleId, 'quizzes', items.quizId]);
  }

  //#endregion
}
